import React from "react";
import { ComponenteTabsWeb } from "../../../../../components/ComponenteTabsWeb";
import { useLocation, useNavigate } from "react-router-dom";
import useDynamicColors from "../../../../../hooks/useDynamicColors";
import "./style.css";

export const CorporativoBusinessBankingSignupWeb = () => {
  const colors = useDynamicColors();
  const location = useLocation();
  const navigate = useNavigate();

  const handleButtonClick = () => {
    const currentParams = location.search;
    navigate(`/business_banking-mail-corporativo-web${currentParams}`);
  };

  const options = [
    {
      icon: "/img/empresa.png",
      title:
        "I am a Legal Representative of a Business and want to open an account",
      subtitle: "I am an Attorney-in-Fact of a Legal Entity",
    },
    {
      icon: "/img/tienda.png",
      title: "I am a Guest of a Business and want to log in for the first time",
      subtitle:
        "I received an invitation to become a user of a VeriBank client company",
    },
    {
      icon: "/img/estampilla.png",
      title: "I am an Entrepreneur and want to open an account",
      subtitle: "I am a Sole Proprietor with Commercial Activity",
    },
  ];

  const laptop = {
    marginTop: "30px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: "#333",
    borderRadius: "15px 15px 5px 5px",
    padding: "17px",
    width: "1400px",
    height: "800px",
    position: "relative",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
  };

  const screen = {
    backgroundColor: "white",
    borderRadius: "5px",
    overflowY: "scroll",
    overflowX: "hidden",
    width: "100%",
    height: "800px",
  };

  const container = {
    display: "flex",
    height: "100vh",
  };

  const base = {
    position: "absolute",
    width: "1600px",
    height: "20px",
    backgroundColor: "rgb(170, 170, 170)",
    borderRadius: "0px 0px 10px 10px",
    bottom: 0,
  };

  return (
    <div style={laptop}>
      <div style={screen}>
        <div style={container}>
          <div className="corporativo-business-signup">
            <div className="overlap-wrapper">
              <div className="overlap">
                <div className="overlap-group">
                  <div className="rectangle-cbblw" />

                  <div className="frame-2">
                    <ComponenteTabsWeb
                      login={false}
                      signup={true}
                      atomoTabDivClassName="componente-tabs-web-2"
                      atomoTabDivClassNameOverride="componente-tabs-web-2"
                      atomoTabFrameClassName="componente-tabs-web-instance"
                      atomoTabFrameClassNameOverride="componente-tabs-web-3"
                      atomoTabLine="/img/line-49-2.svg"
                      atomoTabText="Sign up"
                      className="design-component-instance-node"
                    />

                    <div className="account-options-container">
                      {options.map((option, index) => (
                        <div key={index} className="account-option-card">
                          <img
                            src={option.icon}
                            alt="Icon"
                            className="account-option-icon"
                          />
                          <div className="account-option-texts">
                            <div className="account-option-title">
                              {option.title}
                            </div>
                            <div className="account-option-subtitle">
                              {option.subtitle}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>

                    <div onClick={handleButtonClick}>
                      <p>
                        <span className="span">
                          Already started an application?{" "}
                        </span>

                        <span className="text-wrapper-2">Click here</span>
                      </p>
                    </div>
                  </div>

                  <div className="group">
                    <div className="frame-4">
                      © 2025 All rights reserved
                      <img width={100} height="auto" src="/img/veritran.svg" />
                      Innovation Lab
                    </div>
                  </div>

                  <div className="component">
                    {colors.url_logo !== "" && (
                      <img width={30} height="auto" src={colors.url_logo} />
                    )}
                    <div className="language">
                      <img
                        src="https://webfly-j.presales01.veritran.cloud/api/resources/4720/bandera_us"
                        height={30}
                        width={30}
                      />
                    </div>
                  </div>
                </div>

                <div className="slider-wrapper">
                  <div className="slider">
                    <div className="imagen-slider">
                      <div className="imagen-texto">
                        <div className="mobile-login-pana-wrapper">
                          <div className="mobile-login-pana">
                            <div className="overlap-2">
                              <img
                                className="freepik-background"
                                alt="Freepik background"
                                src="/img/imagen-login.png"
                              />

                              <div className="rectangle-2" />
                            </div>
                          </div>
                        </div>

                        <div className="texto">
                          <div className="subtitle-2">
                            VERIBANK <br />
                            Small Business Checking
                          </div>

                          <p className="subtitle-3">
                            An account for your every day business banking needs
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style={base}></div>
    </div>
  );
};
